const utils = {
  forceDownload(blob, filename) {
    var a = document.createElement('a')
    a.download = filename
    a.href = blob
    // For Firefox
    document.body.appendChild(a)
    a.click()
    a.remove()
  },

  // Current blob size limit is around 500MB for browsers
  downloadResource(url, filename, loadingBars) {
    loadingBars.l2 = true
    if (!filename) filename = url.split('\\').pop().split('/').pop()
    var that = this
    fetch(url, {
      headers: new Headers({
        Origin: location.origin,
        'Access-Control-Allow-Origin': '*',
      }),
      mode: 'cors',
    })
      .then((response) => response.blob())
      .then((blob) => {
        let blobUrl = window.URL.createObjectURL(blob)
        that.forceDownload(blobUrl, filename)
        loadingBars.l2 = false
      })
      .catch((e) => {
        console.error(e)
        loadingBars.l2 = false
      })
  },

  getImageSrc(color, selectedStore, item = null, print = false) {
    try {
      if (!color) return ''

      let colorId = color.id

      if (item && color.value === 'default') {
        const defaultColor = item.colors[0]?.toLowerCase().split(' & ')[0]
        colorId =
          defaultColor &&
          selectedStore.colors.find((c) => [c.value, c.id].includes(defaultColor))?.id
      }
      if (!colorId) return ''

      const imgFileName = `${colorId.toLowerCase()}${print ? '_print' : ''}`

      return require(`@/assets/certs/${imgFileName}.png`)
    } catch (error) {
      return ''
    }
  },

  getCoverImageSrc(color, version) {
    try {
      if (!color) return ''

      let colorId = color.value.de
      console.log(color)

      if (!colorId) return ''

      const imgFileName = `${colorId}_${version}`
      console.log(imgFileName)

      return require(`@/assets/covers/${imgFileName}.jpg`)
    } catch (error) {
      return ''
    }
  },

  extractCustomizationInfo(json) {
    // Extract font and color customizations
    const textCustomizations = json.customizationData.children[0].children[0].children[0].children

    const customizationArr = []

    textCustomizations.forEach((customization) => {
      /*  if (
        customization.type === 'FontCustomization' ||
        customization.type === 'ColorCustomization'
      ) {
        customizationArr.push({
          name: customization.label,
          font: customization.fontSelection?.family,
          color: customization.colorSelection?.name,
        })
      }
 */

      if (customization.type === 'ContainerCustomization') {
        customization.children.forEach((subCustom) => {
          subCustom.children.forEach((subSubCustom) => {
            subSubCustom.children.forEach((textCustom) => {
              customizationArr.push({
                name: subSubCustom.name,
                label: textCustom.label,
                inputValue: textCustom.inputValue,
              })
            })
          })
        })
      }
    })

    return { marketplaceId: json.marketplaceId, customization: customizationArr }
  },
}

export default utils
